import { useQuery } from '@tanstack/react-query';

import { getPropertyValue } from '@/types/crm';

import { createCRMObjectClient } from '../core/CRMObjectClient';

/** Fetch the meeting prep brief (ahoy_research associated to meeting) */
export function useMeetingPrepBrief(orgId: number, meetingEntityId: string) {
  return useQuery({
    queryKey: ['meetingPrep', orgId, meetingEntityId],
    queryFn: async () => {
      const client = createCRMObjectClient(orgId, 'ahoy_research');
      const response = await client.list(
        {
          associated_with_entity_id: meetingEntityId,
          properties: [
            'ahoy_summary',
            'ahoy_status',
            'ahoy_created_at',
            'ahoy_research_type',
            'ahoy_view_definition',
          ],
          order_by: '-ahoy_created_at',
        },
        { signal: AbortSignal.timeout(10_000) }
      );
      return response.results.filter(item => {
        const researchType = getPropertyValue<string>(
          item.properties?.ahoy_research_type
        );
        return researchType === 'meeting_prep';
      });
    },
    enabled: !!meetingEntityId,
    staleTime: 5 * 60_000,
  });
}
